import React, { FC, ReactElement } from 'react'
import { CodeAddModify } from '../../../../i18n'
// Language
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import FormRow from '../../Common/Components/FormRow'
import { InputHelp } from '../../Common/Components/InputHelp/InputHelp'
import { SelectOptions } from '../../Common/Components/Selects'
import { ValidationErrors } from '../../Common/Components/ValidationErrors/ValidationErrors'
import { CodeTypesValues } from '../Constants/Constants'
import {
    CODE_GENERAL_NAME,
    CODE_TYPE_GENERAL_NAME,
    DESCRIPTION_GENERAL_NAME,
    GUID_GENERAL_NAME,
    UPDATE_EXISTING_GENERAL_NAME
} from '../Constants/FieldNames'
import { OutlinedTextInput } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'
import { OutlinedSelect } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedSelect'
import { RouterCheckbox } from '../../../ReactRouting/Components/Atoms/Inputs/RouterCheckbox'

type Props = {
    viewOnly: boolean | undefined
    isCodeSelected: boolean | undefined
}

const GeneralOptions: FC<Props> = ({ viewOnly, isCodeSelected }: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(CodeAddModify.NAME)

    const CodeTypes: SelectOptions<number> = [
        {
            label: language.get(CodeAddModify.CodeTypeOptionOne),
            value: CodeTypesValues.ACCOUNT_CODE
        },
        {
            label: language.get(CodeAddModify.CodeTypeOptionTwo),
            value: CodeTypesValues.AGENT_NA
        }
    ]

    return (
        <div className='user-details-tab tab-area'>
            <FormRow>
                <ValidationErrors name={GUID_GENERAL_NAME}>
                    <OutlinedTextInput
                        placeholder={language.get(CodeAddModify.GUIDPlaceholder)}
                        labelLeft={language.get(CodeAddModify.GUID)}
                        inputName={GUID_GENERAL_NAME}
                        disabled={viewOnly || isCodeSelected}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={CODE_GENERAL_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CodeAddModify.Code)}
                        inputName={CODE_GENERAL_NAME}
                        rules={{
                            maxLength: {
                                value: 100,
                                message: language.get(CodeAddModify.Errors_CodeAddModify_Code_Length)
                            },
                            required: language.get(CodeAddModify.Errors_Code_Required)
                        }}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <InputHelp text={language.get(CodeAddModify.CodeTypeHelp)}>
                    <OutlinedSelect
                        name={CODE_TYPE_GENERAL_NAME}
                        label={language.get(CodeAddModify.CodeType)}
                        options={CodeTypes}
                        defaultValue={CodeTypes[0].value}
                        disabled={viewOnly}
                        rules={{ required: true }}
                    />
                </InputHelp>
            </FormRow>
            <FormRow>
                <ValidationErrors name={DESCRIPTION_GENERAL_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CodeAddModify.Description)}
                        inputName={DESCRIPTION_GENERAL_NAME}
                        disabled={viewOnly}
                        rules={{
                            maxLength: {
                                value: 100,
                                message: language.get(CodeAddModify.Errors_CodeAddModify_Description_Length)
                            }
                        }}
                    />
                </ValidationErrors>
            </FormRow>
            {!isCodeSelected ? (
                <FormRow>
                    <RouterCheckbox
                        labelLeft={language.get(CodeAddModify.UpdateExisting)}
                        name={UPDATE_EXISTING_GENERAL_NAME}
                        defaultChecked={false}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
        </div>
    )
}

export default GeneralOptions
